import React from 'react';
import SEO from "../common/SEO";
import {Link} from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import HeaderOne from '../common/header/HeaderOne';
import HeaderTopBar from '../common/header/HeaderTopBar';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import AboutEquality from '../elements/about/AboutEquality';
import Separator from "../elements/separator/Separator";






const EqualityAndDiversity = () => {
    return (
        <>
            <SEO title="EqualityAndDiversity" />
            <main id="main-content" className="page-wrapper" aria-label="Main content">
                <HeaderTopBar />
                <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

               
                <Separator />

                {/* Start About Area  */}
                <AboutEquality/>                            
                {/* End About Area  */}

                

                <Separator />   
               
                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default EqualityAndDiversity;
